import React from 'react';
import { CartFooterProps } from 'types';
import { Button } from '../../button';

export default function LocationFilter(props: CartFooterProps) {
  return (
    <div className="p-0 flex flex-col gap-4">
      <h4 className="p-0 m-0 text-lg">Biler på lager basert på lokasjon</h4>
      <div className="flex items-start pb-0 gap-2 flex-wrap w-full">
        {props.location?.length > 0 ? (
          props.location?.map((element) => {
            const sellerKey = element?.id as keyof NonNullable<CartFooterProps['vehicleCountBySeller']>;
            const innerObject =
              props.vehicleCountBySeller && props.vehicleCountBySeller[sellerKey]
                ? (props.vehicleCountBySeller[sellerKey] as Record<string, number | undefined>)
                : undefined;

            const key: string =
              innerObject && Array.isArray(Object.keys(innerObject)) ? Object.keys(innerObject)[0] : '';

            const count = innerObject && Number(innerObject[key]) ? innerObject[key] : 0;
            return (
              <Button
                key={element?.id}
                className="p-2 px-4"
                variant="teal"
                appearance={'outline'}
                disabled={count <= 0}
                onClick={(): void => {
                  if (count > 0) {
                    props.onOpenVehicleList(key);
                    props.onSellerChangeByCount(key);
                  }
                }}
              >
                <span>{element?.name ? `${element?.name} (${count})` : ''}</span>
              </Button>
            );
          })
        ) : (
          <p>Ingen plassering funnet</p>
        )}
      </div>
    </div>
  );
}
